import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InfoTooltip } from 'app/modules/models/infoTooltip.type';
import { InfoTooltipViewerComponent } from '../info-tooltip-viewer/info-tooltip-viewer.component';
import { MatDialog } from '@angular/material/dialog';
import { InfoTooltipService } from 'app/shared/services/infoTooltip.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-info-tooltip-button',
  templateUrl: './info-tooltip-button.component.html',
  styleUrls: ['./info-tooltip-button.component.scss']
})
export class InfoTooltipButtonComponent implements OnInit {
  info: InfoTooltip = {
    isActive: false
  };
  @Input() buttonId: string;
  @Output() valueEvent = new EventEmitter<any>();
  constructor(
    private _infoTooltipService: InfoTooltipService,
    public _dialog: MatDialog,
    private _snackBar: MatSnackBar,
  ) { }



  ngOnInit(): void {
    this.getInfoByButtonId();
  }

  get isInfoActive(): boolean {
    if (this.info?.isDeleted === true) {
      return false;
    }

    if (this.info?.isActif !== undefined && this.info?.isActif !== null) {
      return this.info.isActif === 1 || this.info.isActif === true;
    }

    return this.info?.isActive === true;
  }

  showQuill(event: Event) {
    event.stopPropagation();

    if (!this.isInfoActive) {
      return;
    }

    this._dialog.open(InfoTooltipViewerComponent, {
      minHeight: '300px',
      width: '800px',
      data: { info: this.info },
    });

  }
  getInfoByButtonId() {
    this._infoTooltipService.getActiveByButtonId(this.buttonId).subscribe({
      next: (infoTooltip: InfoTooltip) => {
        this.info = infoTooltip;
        // This is a method to refresh and ensure that the button will be displayed properly
        this.valueEvent.emit(this.info);
      },
      error: err => {
        this._snackBar.open('Une erreur serveur est survenue !', null, { duration: 2000, panelClass: 'warn-snackbar' });
      }
    });
  }
}
